import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, autorun, action, toJS } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../Form';

@inject('userStore', 'roleStore')
@observer
class UserEdit extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      userId: PropTypes.string.isRequired,
    }).isRequired,
  };

  slug = '/user';
  title = 'Edit User';
  dispose = null;
  @observable passwordVisible = false;
  @observable retypePassword = ''
  @observable user = {};
  @observable roles = [];

  constructor(props) {
    super(props);

    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const { params: { userId }, userStore, roleStore } = this.props;
    roleStore.fetchItems();
    userStore.fetchItem(userId);

    this.dispose = autorun(() => {
      const foundUser = userStore.findById(userId);
      const foundRoles = roleStore.items.toJS();
      this.reset(foundUser, foundRoles);
    });
  }

  componentWillUnmount() { this.dispose(); }

  @action reset(foundUser, foundRoles) {
    if (foundUser) {
      this.user = {
        ...foundUser.asJson,
        password: ''
      };
    }
    if (foundRoles) { this.roles = foundRoles; }
  }

  @action onChangeName = (e) => { this.user.name = e.target.value; }
  @action onChangeUsername = (e) => { this.user.username = e.target.value; }
  @action onChangeDesignation = (e) => { this.user.designation = e.target.value; }
  @action onChangePassword = (e) => { this.user.password = e.target.value; }
  @action onChangeRole = (e) => { this.user.role_id = e.target.value; }
  @action onChangeEmail = e => this.user.email = e.target.value;
  @action onChangeMobile = e => this.user.mobile = e.target.value;

  onChange(field, event) {
    this.user = {
      ...this.user,
      [field]: event.target.value,
    };
  }

  handleSave(e) {
    e.preventDefault();
    const {router, notify} = this.context;
    const { userStore } = this.props;
    if(this.user.password !== this.retypePassword) {
      notify.error({message: 'Passwords do not match.'});
      return;
    }
    userStore.updateItem(this.user)
      .then(() => {
        notify.success({message: 'User updated successfully.'});
        router.push(this.slug);
      }).catch(err => {
        notify.error({message: err.toString()});
      });
  }

  render() {
    const { userStore, roleStore } = this.props;

    if (userStore.isSpinner) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={userStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Id'} value={this.user.id} readOnly />
            <TextInput label={'Username'} value={this.user.username} onChange={this.onChangeUsername} />
            <TextInput label={'Name'} value={this.user.name} onChange={this.onChangeName} />
            <TextInput label={'Designation'} value={this.user.designation} onChange={this.onChangeDesignation} />

            <SelectInput
              label={'Role'}
              fields={{ label: 'name', value: 'id' }}
              options={this.roles}
              onChange={this.onChangeRole}
              value={this.user.role_id}
            />
            <TextInput label={'Password'} value={this.user.password} onChange={this.onChangePassword} type={'password'} />
            <TextInput label={'Retype Password'} value={this.retypePassword} onChange={e => this.retypePassword = e.target.value} type={'password'} />
            <TextInput label={'Email'} value={this.user.email} onChange={this.onChangeEmail} />
            <TextInput label={'Mobile No.'} value={this.user.mobile} onChange={this.onChangeMobile} />

          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default UserEdit;



// WEBPACK FOOTER //
// ./src/components/User/UserEdit.js